import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Project } from '../../../types';

interface ProjectHeaderProps {
  project: Project;
  canEdit?: boolean;
  onDelete?: () => void;
}

const ProjectHeader: React.FC<ProjectHeaderProps> = ({ project, canEdit, onDelete }) => {
  const navigate = useNavigate();

  return (
    <div className="border-b border-gray-200 px-6 py-3 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <button
          onClick={() => navigate(-1)}
          className="p-1 hover:bg-gray-100 rounded transition-colors"
        >
          <svg className="w-5 h-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <span className="text-sm text-gray-500 capitalize">
          {project.projectType || 'Project'}
          {project.hierarchyLevel > 0 && ` • Level ${project.hierarchyLevel}`}
        </span>
      </div>
      <div className="flex items-center gap-3">
        <div className="text-xs text-gray-500">
          Created {new Date(project.createdAt).toLocaleDateString()}
        </div>
        {canEdit && onDelete && (
          <button
            onClick={onDelete}
            className="px-3 py-1 text-sm bg-red-600 text-white rounded hover:bg-red-700 transition-colors"
          >
            Delete Project
          </button>
        )}
      </div>
    </div>
  );
};

export default ProjectHeader;
